import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import ListProxyByStatus from "./ListProxyByStatus";

const AdminListProxyByStatusPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectChangeUser = (listId) => {
        navigate('/admin/proxy/chuyen-khach-hang.html?' + listId);
    }

    return <ListProxyByStatus
        statusParams={ params.status }
        redirectChangeUser={ (listId) => redirectChangeUser(listId) }
    />

}

export default AdminListProxyByStatusPage;